import { useTrustpilotStats, formatRelativeTime } from "@/hooks/useTrustpilotStats";

const TrustpilotMiniStars = ({ rating }: { rating: number }) => (
  <span className="inline-flex gap-[1px]">
    {[...Array(5)].map((_, i) => {
      const fillPercent = Math.min(100, Math.max(0, (rating - i) * 100));
      const isFull = fillPercent >= 100;
      return (
        <span key={i} className="relative flex-shrink-0 w-[18px] h-[18px]">
          <svg className="absolute inset-0 w-full h-full" viewBox="0 0 96 96" preserveAspectRatio="xMidYMid meet">
            <rect fill="#DCDCE6" width="96" height="96" />
            <path d="M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 Z" fill="#FFFFFF" />
          </svg>
          {fillPercent > 0 && (
            <span className="absolute top-0 left-0 h-full overflow-hidden" style={{ width: isFull ? '100%' : `${fillPercent}%` }}>
              <svg className="h-full" viewBox="0 0 96 96" preserveAspectRatio="xMinYMid slice" style={{ width: 18 }}>
                <rect fill="#00B67A" width="96" height="96" />
                <path d="M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 Z" fill="#FFFFFF" />
              </svg>
            </span>
          )}
        </span>
      );
    })}
  </span>
);

const PillReviewTicker = () => {
  const { reviews, loading } = useTrustpilotStats();

  if (loading || reviews.length === 0) return null;

  const sorted = [...reviews]
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 5);

  const items = [...sorted, ...sorted];
  const totalChars = sorted.reduce((sum, r) => sum + r.text.length + r.author.length + 20, 0);
  const duration = Math.max(15, totalChars * 0.036); // ~36ms per character, min 15s

  return (
    <div className="bg-navy text-white overflow-hidden py-1.5 mt-2">
      <div
        className="whitespace-nowrap tracking-tight"
        style={{
          display: 'inline-flex',
          animation: `ticker ${duration}s linear infinite`,
          width: 'max-content',
        }}
      >
        {items.map((review, idx) => (
          <div key={idx} className="inline-flex items-center gap-2 px-4 flex-shrink-0">
            <TrustpilotMiniStars rating={review.rating} />
            <span className="text-xs whitespace-nowrap">{review.text}</span>
            <span className="text-[11px] text-peach font-medium whitespace-nowrap">, {review.author}</span>
            <span className="text-[9px] text-white/40 whitespace-nowrap">{formatRelativeTime(review.date)}</span>
            <span className="text-white/20 mx-3">|</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PillReviewTicker;
